import {
  createContext,
  Dispatch,
  FC,
  SetStateAction,
  useCallback,
  useEffect,
  useState,
} from "react";

type ContextType = {
  isExpanded: boolean;
  setIsExpanded: Dispatch<SetStateAction<boolean>> | ((value: boolean) => null);
};

const defaultValue: ContextType = {
  isExpanded: false,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setIsExpanded: (value: boolean) => null,
};

export const SidebarContext = createContext<ContextType>(defaultValue);

export const SidebarProvider: FC = ({ children }) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const [oldWidth, setOldWidth] = useState<number>(0);

  const onResize = useCallback(() => {
    // ignore height change
    if (oldWidth !== window.innerWidth) {
      console.log(window.innerWidth, "isExpanded", window.innerWidth > 482);
      setIsExpanded(window.innerWidth > 482);
    }

    setOldWidth(window.innerWidth);
  }, [oldWidth]);

  useEffect(() => {
    onResize();
    window.addEventListener("resize", onResize);

    return () => window.removeEventListener("resize", onResize);
  }, [onResize]);

  useEffect(() => {
    console.log({ isExpanded });
    setOldWidth(window.innerWidth);
  }, [isExpanded]);

  return (
    <SidebarContext.Provider value={{ isExpanded, setIsExpanded }}>
      {children}
    </SidebarContext.Provider>
  );
};
